import styled from 'styled-components'

export const StationKnowledgeSaleWrapper = styled.div`
`
export const KnowledgeSaleDesc = styled.div`
    color: #575757;
    font-size: 18px;
    text-align: center;
    padding: 0 16px;
    width: 100%;
    margin: 16px;
`
